import React, { Component } from 'react';
import { List, Image } from 'semantic-ui-react';

export default class ValueElement extends Component {
    render() {

        const {value} = this.props;

        if(!value || (value.gold === 0 && value.silver === 0 && value.platinum === 0)) {
            return null;
        }

        return (
            <List horizontal={true} floated='right'>
                <List.Item>
                    {value.platinum}
                    <Image src={`\\images\\ui_assets\\coins_platinum.png`}/>
                </List.Item>
                <List.Item>
                    {value.gold}
                    <Image src={`\\images\\ui_assets\\coins_gold.png`}/>
                </List.Item>
                <List.Item>
                    {value.silver}
                    <Image src={`\\images\\ui_assets\\coins_silver.png`}/>
                </List.Item>
            </List>
        );
    }
}


// WEBPACK FOOTER //
// ./src/common/ValueElement.jsx